module.exports = __webpack_public_path__ + "img/snowcabin.b595e70f.jpg";